import { useContext, useEffect, useState } from "react"
import _ from "lodash"
import { gql, useQuery } from "@apollo/client"

import { Field } from "formik"
import { UserContext } from "../../../context/userContext"
import { FormContext } from "../../../context/formContext"
import { MultiSelect } from "primereact/multiselect"

import styles from "../../../styles/Form.module.css"
import { LoaderProgressBar } from "../../Loaders"

export default function ParticipantNoteList(props) {
  const { field, index, mfFieldName, mfIndex } = props
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const [participantList, setParticipantList] = useState(null)
  const userCtx = useContext(UserContext)
  const form = useContext(FormContext)
  const fieldSlug = `${mfFieldName}.${mfIndex}.${field.field_name}`

  const GET_PARTICIPANTS = gql`
    query ParticipantNoteList($staff_id: ID!, $organization_id: ID!) {
      participants: getAllActiveParticipants(
        staff_id: $staff_id
        organization_id: $organization_id
      ) {
        participant_id
        participant_membership_status
        participant_name_first
        participant_name_last
      }
    }
  `

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { loading } = useQuery(GET_PARTICIPANTS, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    skip: !userCtx,
    onCompleted: ({ participants }) => {
      const newParticipantList = _.map(participants, (participant) => {
        return {
          participant_id: participant.participant_id,
          name: `${_.unescape(participant.participant_name_first)} ${_.unescape(
            participant.participant_name_last
          )}`,
        }
      })

      return setParticipantList(newParticipantList)
    },
  })

  const handleSelectParticipant = ({ e, form }) => {
    if (e.value === null) {
      form.setFieldValue(fieldSlug, "")
    } else {
      form.setFieldValue(fieldSlug, e.value)
    }
  }

  if (loading) return <LoaderProgressBar />

  return (
    <div className={styles.field} style={{ order: index }}>
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={fieldSlug}>
          {({ meta, field: formikField, form }) => (
            <>
              <MultiSelect
                value={formikField.value}
                options={participantList}
                onChange={(e) => handleSelectParticipant({ e, form })}
                showClear
                optionLabel="name"
                filter
                filterBy="name"
                placeholder="Select Participants"
                selectionLimit={1}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
